export default "__VITE_ASSET__C_0q$uXD__"